import { useAccessToken, useStandardErrorHandler } from "modules/common";
import { useMutation, UseMutationOptions, useQueries, useQueryClient } from "@tanstack/react-query";
import {
    FilterPreference,
    FilterPreferenceResponse,
    getFilterPreferences,
    updateFilterPreferences,
    UpdateFilterPreferencesRequest,
} from "services/account";

export const useGetFilterPreferencesQuery = (filterNames: string[]) => {
    const accessToken = useAccessToken();
    const errorHandler = useStandardErrorHandler("Greška pri dohvaćanju vrijednosti filtera");

    return useQueries({
        queries: filterNames.map(filterName => ({
            queryKey: ["filterPreferences", filterName],
            queryFn: () => getFilterPreferences(accessToken!, filterName),
            enabled: Boolean(accessToken),
            onError: errorHandler,
        })),
    });
};

export const useUpdateFilterPreferences = (
    options?: UseMutationOptions<FilterPreferenceResponse, unknown, UpdateFilterPreferencesRequest>
) => {
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();
    const errorHandler = useStandardErrorHandler("Greška pri ažuriranju filtera");

    return useMutation({
        mutationFn: (data) => updateFilterPreferences(data, accessToken!),
        onError: errorHandler,
        onSuccess: (_, requestData: UpdateFilterPreferencesRequest) => {
            queryClient.invalidateQueries(["filterPreferences", requestData.filterName]);
        },
        ...options,
    });
};
